import React from "react";
import { Text, View, Svg, Path } from "@react-pdf/renderer";

const ViewerAttachmentItem = ({ fileName }: { fileName: string }) => {
  // fileName을 명시적으로 정규화하고 클린업
  const cleanFileName = React.useMemo(() => {
    if (!fileName) return "";
    // 한글 조합 문자 정규화
    const normalized = fileName.normalize("NFC");
    // 파일명이 너무 길면 말줄임표 추가 (약 22자 제한)
    const maxLength = 22;
    if (normalized.length > maxLength) {
      return normalized.substring(0, maxLength) + "...";
    }
    return normalized;
  }, [fileName]);

  return (
    <View
      style={{
        display: "flex",
        flexDirection: "row",
        alignItems: "flex-start",
        gap: "1.5mm",
        padding: "1mm",
      }}
    >
      <Svg width="13" height="11" viewBox="0 0 13 11">
        <Path
          d="M9.4569 3.16731L5.26344 7.43666C4.76479 7.94434 3.95632 7.94434 3.45768 7.43666C2.95798 6.92793 2.95918 6.10272 3.46035 5.5955L6.71226 2.30428L7.52892 1.47284C8.52258 0.4612 10.1336 0.461201 11.1273 1.47284C12.1209 2.48448 12.1209 4.12467 11.1273 5.13631L10.3229 5.95525L7.27429 9.05902C5.69733 10.7314 3.30782 10.9859 1.63714 9.353C-0.0130906 7.74011 0.266618 5.32201 1.93517 3.62326L4.97175 0.53125"
          stroke="#9AA1AB"
          stroke-width="1.06315"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
      </Svg>

      <Text
        style={{
          fontFamily: "Pretendard",
          fontSize: "10pt",
        }}
      >
        {cleanFileName}
      </Text>
    </View>
  );
};

export default ViewerAttachmentItem;
